//import external libraries
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

//import internal services and resources
import ProjectsTable from "../projects/ProjectsTable";
import UsersTable from "./UsersTable";
import { getAllUsers } from "../../utils/services/userService";
import { getAllProjectsAdmin } from "../../utils/services/projectService";

//import MUI components
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import ViewListIcon from "@mui/icons-material/ViewList";
import { useTheme } from "@mui/material/styles";
import { Provider } from "../../utils/hooks/filterContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function AdminDashboard() {
  const theme = useTheme();
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("jwt");

    getAllUsers(token).then((res) => setUsers(res));

    getAllProjectsAdmin().then((res) => setProjects(res.data.data));
  }, []);
  const initialFilter = {
    items: [
      {
        columnField: "id",
        operator: "contains",
        operatorValue: "contains",
        value: "",
      },
    ],
  };
  const [filterParameters, setFilterParameters] = useState(initialFilter);

  return (
    <>
      <Provider
        value={{
          filterParameters,
          setFilterParameters,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: theme.palette.primary.main,
              }}
            >
              <DashboardIcon sx={{ width: 50, height: 50, m: 1 }} />
              <Typography
                component="h1"
                variant="h5"
                sx={{ margin: 2, color: theme.palette.primary.main }}
              >
                {t("adminPanel.mydashboard")}
              </Typography>
            </Box>
            <Divider sx={{ mb: 4 }} />
          </Grid>
          {/* <Grid item xs={3}>
          <Paper>
            <Grid container>
              <Grid item xs={6}>
                <GroupIcon fontSize="64px" />
              </Grid>
              <Grid item xs={6}>
                <Typography>Active projects </Typography>
                <Typography> {projects.length}</Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper>
            <Grid container>
              <Grid item xs={6}>
                <GroupIcon fontSize="64px" />
              </Grid>
              <Typography>Number of users </Typography>
              <Typography>{users.length}</Typography>
            </Grid>
          </Paper>
        </Grid>
          <Grid item xs={3}></Grid>*/}
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: theme.palette.primary.main,
              }}
            >
              <GroupIcon sx={{ width: 50, height: 50, m: 1 }} />
              <Typography
                component="h1"
                variant="h5"
                sx={{ margin: 2, color: theme.palette.primary.main }}
              >
                {t("adminPanel.users")}
              </Typography>
            </Box>
            <Divider sx={{ mb: 4 }} />
            <UsersTable
              projects={users}
              // refreshDashboardData={refreshDashboardData}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: theme.palette.primary.main,
              }}
            >
              <ViewListIcon sx={{ width: 50, height: 50, m: 1 }} />
              <Typography
                component="h1"
                variant="h5"
                sx={{ margin: 2, color: theme.palette.primary.main }}
              >
                {t("adminPanel.projects")}
              </Typography>
            </Box>
            <Divider sx={{ mb: 4 }} />
            <ProjectsTable
              projects={projects}
              // refreshDashboardData={refreshDashboardData}
            />
          </Grid>
        </Grid>
      </Provider>
    </>
  );
}

export default AdminDashboard;
